import dayjs from "dayjs";
import appointmentApi from "../../../services/api/Appointment";
import { AppointmentStatus } from "../../../types/types";
import { IRating } from "../../../services/api/Rating/types";
import ratingApi from "../../../services/api/Rating";

export const handleFinishAppointmentClick = async (appointmentId: string) => {
  const updatedAppointment = {
    status: AppointmentStatus.FINISHED,
  };

  try {
    await appointmentApi.updateAppointment(appointmentId, updatedAppointment);
  } catch (error) {
    console.warn("Error finishing appointment: ", error);
  }
};

export const handleCancelAppointmentClick = async (
  cancellationReason: string,
  appointmentId: string,
  serviceEmployeeId: string
) => {
  const today = dayjs().toISOString();

  const updatedAppointment = {
    serviceEmployeeId: serviceEmployeeId,
    cancelationReason: cancellationReason,
    canceledAt: today,
    status: AppointmentStatus.CANCELED,
  };

  try {
    await appointmentApi.updateAppointment(appointmentId, updatedAppointment);

    location.reload();
  } catch (error) {
    console.warn("Error cancelling the appointment: ", error);
  }
};

export const handleRateService = async (
  appointmentId: string,
  rating: number,
  comment: string
) => {
  const newRating: IRating = {
    appointmentId,
    rating,
    comment,
    who: "CLIENT",
  };

  try {
    await ratingApi.createRating(newRating);
  } catch (error) {
    console.error("Error rating the service: ", error);
  }
};
